class RealTimePrice {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="RealTimePrice"]'),
      lang: document.documentElement.lang || 'nl',
      currency: 'euro',
      currencyList: {
        euro: '\u20ac'
      },
      ...options
    };
  }

  init() {
    const { moduleList, lang, currency, currencyList } = this.config;

    moduleList.forEach(module => {
      const { productId, authenticated, priceInitialized } = module.dataset;
      if (priceInitialized) return;

      module.dataset.priceInitialized = 'true';
      const isAuthenticated = authenticated === 'True';
      const container = module.querySelector('[data-price-container]');
      if (!productId || !container) return;
      const crossSellRow = document.querySelector(`.js-realtime[data-product-id="${productId}"]`);
      module.classList.add('is-loading');

      fetch(`/api/v2/catalog/product/${productId}/prices`, {
        method: 'GET',
        headers: {
          'Accept-Language': lang
        }
      })
        .then(res => res.json())
        .then(json => {
          // eslint-disable-next-line no-underscore-dangle
          const { prices } = json._embedded;

          // prices[0].currentPriceInclVat
          container.innerHTML = prices.length
            ? `${currencyList[currency] || ''} ${parseFloat(
                isAuthenticated ? prices[0].currentPrice : prices[0].currentPrice
              )
                .toFixed(2)
                .toString()
                .replace('.', ',')}`
            : module.dataset.nullPrice || 'Upon request';

          module.classList.remove('is-loading');
        })
        .catch(() => {
          container.innerHTML = module.dataset.errorMessage || 'Price not available';
          module.classList.remove('is-loading');
          module.classList.add('is-error');
          if (!crossSellRow) return;
          crossSellRow.classList.add('hidden');
        });
    });
  }
}

export default RealTimePrice;
